<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Adicionar Locação</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-radio-group v-model="rental.type" :mandatory="true" row hide-details class="mt-0">
                <v-radio label="Residencial" value="Residencial"></v-radio>
                <v-radio label="Comercial" value="Comercial"></v-radio>
                <v-radio label="Industrial" value="Industrial"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12">
              <ImmobileSelector
                label="Imóveis"
                v-model="rental.immobiles"
                outlined
                dense
                chips
                small-chips
                deletable-chips
                multiple
              />
            </v-col>

            <v-col cols="12">
              <ClientSelector
                outlined
                dense
                chips
                small-chips
                deletable-chips
                label="Locatários"
                v-model="rental.tenant"
                multiple
              />
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="rental.guarantorType"
                :items="guarantorTypes"
                label="Tipo de Fiador"
                outlined
                dense
                item-text="label"
                item-value="value"
                hide-details
              />
            </v-col>

            <v-col cols="12" v-if="rental.guarantorType === 'PERSON'">
              <ClientSelector
                outlined
                dense
                chips
                small-chips
                deletable-chips
                label="Fiadores"
                v-model="rental.guarantor"
                multiple
              />
            </v-col>
            <v-col cols="12" v-if="rental.guarantorType === 'INSURANCE'">
              <v-text-field
                v-model="rental.insuranceCompany"
                label="Seguradora"
                outlined
                dense
                :rules="[v => !!v || 'Campo obrigatório']"
              />
              <v-text-field
                v-model="rental.insurancePolicy"
                label="Apólice"
                outlined
                dense
                :rules="[v => !!v || 'Campo obrigatório']"
              />
              <v-text-field
                v-model="rental.insurancePolicyNumber"
                label="Número da Apólice"
                outlined
                dense
                :rules="[v => !!v || 'Campo obrigatório']"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="px-8 pb-8">
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mr-2 mt-2" outlined :disabled="loading" @click="close">Cancelar</v-btn>
        <v-btn color="primary" class="mt-2" @click="save" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RENTAL from '@/services/rental'
import ClientSelector from '../global/ClientSelector.vue'
import ImmobileSelector from '../global/ImmobileSelector.vue'
const defaultData = () => ({
  type: 'Residencial',
  immobiles: [],
  tenant: [],
  guarantor: [],
  guarantorType: 'PERSON',
  insuranceCompany: '',
  insurancePolicy: '',
  insurancePolicyNumber: '',
})
export default {
  components: { ClientSelector, ImmobileSelector },
  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      guarantorTypes: [
        { label: 'Pessoas Físicas/Jurídicas', value: 'PERSON' },
        { label: 'Seguradora', value: 'INSURANCE' },
        { label: 'Sem Fiador', value: 'NONE' },
      ],
      rental: defaultData(),
    }
  },
  methods: {
    async save() {
      try {
        this.loading = true
        this.validate()
        var obj = {
          type: this.rental.type,
          immobiles: this.rental.immobiles,
          guarantorType: this.rental.guarantorType,
          insurancePolicy: this.rental.insurancePolicy,
          insuranceCompany: this.rental.insuranceCompany,
          insurancePolicyNumber: this.rental.insurancePolicyNumber,
          clients: [
            ...this.rental.tenant.map(t => ({ id: t, type: 'Tenant' })),
            ...this.rental.guarantor.map(g => ({ id: g, type: 'Guarantor' })),
          ],
        }
        let response
        if (this.rental.id) response = await RENTAL.update(this.rental.id, obj)
        else response = await RENTAL.create(obj)

        this.$emit('success')
        if (!this.rental.id) this.$router.push({ name: 'rental.edit', params: { id: response.rental.id } })
        else this.close()
      } catch (error) {
        console.log(error)
        this.$toast.fire({
          icon: 'error',
          title: error.message || 'Erro ao salvar imóvel',
        })
        this.$emit('error', error)
        this.loading = false
      }
    },
    open(data) {
      this.dialog = true
      this.rental = Object.assign(defaultData(), data)
      if (data) {
        this.rental.type = data.type
        this.rental.immobiles = data.Immobiles.map(i => i.id)
        this.rental.guarantorType = data.guarantorType
        this.rental.insuranceCompany = data.insuranceCompany
        this.rental.insurancePolicy = data.insurancePolicy
        this.rental.insurancePolicyNumber = data.insurancePolicyNumber
      }
    },
    close() {
      this.loading = false
      this.dialog = false
      this.rental = defaultData()
    },
    validate() {
      if (this.rental.immobiles.length === 0) throw new Error('Selecione ao menos um imóvel')
      if (this.rental.tenant.length === 0) throw new Error('Selecione ao menos um locatário')

      switch (this.rental.guarantorType) {
        case 'PERSON':
          if (this.rental.guarantor.length === 0) throw new Error('Selecione ao menos um fiador')
          break
        case 'INSURANCE':
          if (this.rental.insuranceCompany === '') throw new Error('Informe a seguradora')
          if (this.rental.insurancePolicy === '') throw new Error('Informe a apólice')
          if (this.rental.insurancePolicyNumber === '') throw new Error('Informe o número da apólice')
          break
      }
    },
  },
  created() {
    this.$parent.$on(this.componentName, this.open)
  },
  props: {
    componentName: {
      type: String,
      default: 'rental-modal',
    },
  },
}
</script>

<style></style>
